import { TCreateTagFields } from 'shared/types'
import { api } from '..'

export type TCreateTagResponse = {
  tagId: string
}

export const createTag = (data: TCreateTagFields) =>
  api.post<TCreateTagResponse>('/v1/tags', data).then(({ data }) => data)
